import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { green, blue } from '@material-ui/core/colors'
import styled from 'styled-components'
import { Icon, Grow, Typography } from '@material-ui/core'
import ColorButton from './ColorButton'
import { Manager, Target, Popper } from 'react-popper'
import { toggleFilter } from './modules/filters'
import { Shadow, Radius } from './styles'

const PaperContainer = styled.div`
    width: 20rem;
    height: 56px;
    margin-right: 2rem;
    display: flex;
    align-items: center;
`

const TooltipPaper = styled.div`
    ${Shadow};
    ${Radius};
    background: white;
    padding: 1rem;
    flex-grow: 1;
`

const MenuButton = styled(ColorButton)`
    margin-bottom: 1rem;
    box-shadow: none;

    @media (max-width: 768px) {
        width: 4rem;
        height: 4rem;
    }
`

const MenuIcon = styled(Icon)`
    font-size: 4rem;

    @media (max-width: 768px) {
        font-size: 2.5rem;
    }
`

class MenuItem extends Component {
    constructor(props) {
        super(props)
        this.state = {
            popperOpen: false
        }
    }

    handlePopperOpen = () => {
        this.setState({ popperOpen: true })
    }

    handlePopperClose = () => {
        this.setState({ popperOpen: false })
    }

    render() {
        return (
            <Manager>
                <Target>
                    <MenuButton
                        variant="fab"
                        csscolor={this.props.isActive ? green : blue}
                        colorlevel={600}
                        onMouseOver={this.handlePopperOpen}
                        onMouseOut={this.handlePopperClose}
                        onClick={() =>
                            this.props.toggleFilter(this.props.filter)
                        }
                    >
                        <MenuIcon>{this.props.icon}</MenuIcon>
                    </MenuButton>
                </Target>
                <Popper placement="left-start">
                    <Grow in={this.state.popperOpen}>
                        <PaperContainer>
                            <TooltipPaper>
                                <Typography>{this.props.tooltip}</Typography>
                            </TooltipPaper>
                        </PaperContainer>
                    </Grow>
                </Popper>
            </Manager>
        )
    }
}

export default connect(
    state => ({}),
    dispatch =>
        bindActionCreators(
            {
                toggleFilter
            },
            dispatch
        )
)(MenuItem)



// WEBPACK FOOTER //
// ./src/MenuItem.js